import { graphql } from '@/gql/codegen/gql';
import { useMutation } from '@apollo/client';
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import toast from 'react-hot-toast';

type UseAgrreTermOfUseProps = {
  redirectTo: string;
};

export const AGREE_TERMS_MUTATION = graphql(/* GraphQL */ `
  mutation EmbaAgreeTerms {
    embaAgreeTerms {
      success
    }
  }
`);

export const useAgreeTermOfUse = ({ redirectTo }: UseAgrreTermOfUseProps) => {
  const navigate = useNavigate();
  const [
    agreeTermsMutation,
    { error: agreeTermsMutationError, loading: agreeTermsMutationLoading },
  ] = useMutation(AGREE_TERMS_MUTATION, {});

  const onAgreeTerms = useCallback(async (): Promise<void> => {
    await agreeTermsMutation();

    toast.success('利用規約に同意しました。');

    navigate({
      to: redirectTo,
    });
  }, [agreeTermsMutation, navigate, redirectTo]);

  return {
    onAgreeTerms,
    agreeTermsMutationError,
    agreeTermsMutationLoading,
  };
};
